import { render, staticRenderFns } from "./TkHotelPlanInfo.vue?vue&type=template&id=5af44145&"
import script from "./TkHotelPlanInfo.vue?vue&type=script&lang=js&"
export * from "./TkHotelPlanInfo.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelPlanInfo.vue?vue&type=style&index=0&id=5af44145&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports